import { SetState } from 'zustand';

export interface ICategorizationWidgetSlice {
  taxSavingAmount: number;
  setTaxSavingAmount: (taxSavingAmount: number) => void;
}

const createCategorizationWidgetSlice = (set: SetState<ICategorizationWidgetSlice>) => ({
  taxSavingAmount: 0,
  setTaxSavingAmount: (taxSavingAmount: number) => {
    set({ taxSavingAmount });
  },
});

export default createCategorizationWidgetSlice;
